import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";

import DiscountSubTotal from "../priceWorksheet/discountSubTotal";
import DiscountCommon from "../priceWorksheet/discountCommon";
import {DISCOUNT_MAIN_TYPES} from "../priceWorksheet/discounstInterface";
import {getDiscountCurrentValue} from "../priceWorksheet/discountFunctions";


class ShoppingCartDiscountsListItem extends DiscountCommon {

  static propTypes = {
    discountSection: PropTypes.object.isRequired,
    discount: PropTypes.object.isRequired,
  };

  render() {
    const {discount, discountSection, activeQuoteIndex, hasMultipleWorkSheets, financeActiveDiscount} = this.props;

    const realName = getDiscountCurrentValue(discount, "name", activeQuoteIndex, hasMultipleWorkSheets);

    const isDeposit = discount.discountType === DISCOUNT_MAIN_TYPES.deposit;
    const isDownPayment = discount.discountType === DISCOUNT_MAIN_TYPES.downPayment;

    if (isDownPayment && !financeActiveDiscount) {
      return null;
    }

    if (isDeposit || isDownPayment) {
      return (
        <li className={"scart-block__list-item scart-block__list-item--centered discount--deposit"}>
          <div className={"margin-l-10 margin-t-6 margin-b-6 scart-block__list-item-text discount-cell--name bold"}>
            {realName}
          </div>
          <div className="shoppingcart-block__list-item-total">
          <span className={"price margin-r-8 price--gray"}>
            {this.getInputValue()}
          </span>
          </div>
        </li>
      )
    }

    return (
      <li className="scart-block__list-item scart-block__list-item--centered">
        <div className="scart-block__list-item-text">
          <h4 className={"scart-block__list-item-text-title"
          + (discount.isSubTotal ? " scart-block__list-item-text-title--green": "")}>{realName}</h4>
        </div>
        <div className="shoppingcart-block__list-item-total">
          <span className={"price " + (discount.isSubTotal ? "price--blue" : "price--active")}>
            {discount.isSubTotal
              ? <DiscountSubTotal discount={discount}
                                  quoteIndex={activeQuoteIndex}
                                  discountSection={discountSection}
                                  shoppingCartItem={true}/>
              : this.getDiscountAmount()}
          </span>
        </div>
      </li>
    )
  }
}

const mapStateToProps = (store, ownProps) => {
  const {discountSections, customAddedDiscounts, financeActiveDiscount} = store.priceWorksheetState;
  const {allWizardsValues} = store.wizardState;
  const {activeQuoteIndex} = store.quotesState;
  const {jobIsSaving} = store.serverState;

  return {
    discountSections,
    customAddedDiscounts,
    financeActiveDiscount,
    fabricatorSettings: store.fabricatorState.settings,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    // Total requirements end
    allWizardsValues,
    activeQuoteIndex: Number.isInteger(ownProps.quoteIndex) ? ownProps.quoteIndex : activeQuoteIndex,
    jobIsSaving,
  };
};

export default connect(mapStateToProps, {

})(ShoppingCartDiscountsListItem);
